"use strict";

var _ = require('underscore');

/**
 * Constructs an array of errors in the correct format to be consumed by the Validator class. Proper usage :
 *      var errors = new ErrorList();
 *      errors.add('creators[0].role');
 *      errors.add('creators[1].attribution', 'The attribution is super wrong');
 *      return errors.getErrors();
 *
 * Chaining also enabled :
 *      return errors.add('creators[0].role').getErrors();
 *
 * @returns {ErrorList}
 * @constructor
 */
var ErrorList = function () {
    this._errors = [];
    return this;
};

/**
 * Get array of all error objects
 * @returns {object[]}
 */
ErrorList.prototype.getErrors = function () {
    return this._errors;
};

/**
 * Add 1 error to the error list
 * @param {String} fieldName
 * @param {String} message
 * @param {function|regex} rule
 * @param {string} viewKey
 * @returns {ErrorList}
 */
ErrorList.prototype.add = function (fieldName, message, rule) {
    if (!fieldName || typeof fieldName !== 'string') {
        throw new Error("Field name is required to use error constructor's add method. '" + fieldName + "' provided");
    }

    var obj = { field : fieldName };
    if (message) {
        obj.message = message;
    }
    if (rule) {
        obj.rule = rule.toString();
        if (typeof obj.rule === 'function') {
            obj.rule = obj.rule.replace(/  /g, '').replace(/\n/g, '');
        }
    }

    this._errors.push(obj);
    return this;
};

/**
 * Merge another error list into this error list as in :
 *  var errors = new ErrorList().add('shipmentQuotes');
 *  var mergedErrors = errors.merge(otherErrorList).getErrors();
 *
 * @param {ErrorList} errorList
 * @returns {ErrorList}
 */
ErrorList.prototype.merge = function (errorList) {
    var self = this;
    if (!(errorList instanceof ErrorList)) {
        throw new Error("Only ErrorList instances may be merged by ErrorList.merge. ");
    }

    var array = errorList.getErrors();
    _.each(array, function (error) {
        var args = [error.field];
        if (error.message) {
            args.push(error.message);
        }
        self.add.apply(self, args);
    });

    return this;
};

/**
 * Get a count of the number of errors;
 * @returns {number}
 */
ErrorList.prototype.count = function () {
    return this._errors.length;
};

/**
 * Get the last error
 * @returns {object}
 */
ErrorList.prototype.last = function () {
    return _.last(this._errors);
};

/**
 * WARNING -- THIS HAS NOT BEEN TESTED!!!!!!!!!
 * WARNING -- THIS HAS NOT BEEN TESTED!!!!!!!!!
 * WARNING -- THIS HAS NOT BEEN TESTED!!!!!!!!!
 * @param {*} newValue
 * @param {String} propName
 * @param {Object} searchObj
 * @returns {ErrorList}
 */
/* eslint-disable */
ErrorList.prototype.modifyWhere = function (newValue, propName, searchObj) {
    throw new Error('THIS METHOD HAS NOT BEEN TESTED. ');
    if (_.isUndefined(newValue) || _.isUndefined(propName)) {
        throw new Error("You must specify a new value and a property name to use ErrorList.modifyWhere");
    }
    var errorSet = this._errors;

    // If searchObj was passed then require that it has one of the 3 properties assigned to each error object.
    // If it does then use that search object as a predicate to search this._errors
    if (!_.isUndefined(searchObj)) {
        var requiredProps = ['field', 'message', 'rule'];
        var hasQualifiedProp = false;
        _.each(requiredProps, function (prop) {
            if (searchObj.hasOwnProperty(prop)) {
                hasQualifiedProp = true;
            }
        });

        if (!hasQualifiedProp) {
            var msg = "Search object used in ErrorList.modifyWhere must contain one of the following : [ " +
                requiredProps.join(' | ') + " ]";
            throw new Error(msg);
        }

        errorSet = _.where(this._errors, searchObj);
    }

    _.each(errorSet, function (error) {
        error[propName] = newValue;
    });

    return this;
};
/* eslint-enable */

module.exports = ErrorList;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/validation/deprecated/helpers/ErrorList.js
// module id = 202
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55